import React, { useEffect, useState } from "react";
import { useRootSelector } from "@/infrastructure/hooks";
import { FireSel } from "@/features/firestore";
import { Input, Tabs } from "antd";
import { groupBy } from "lodash";

import TemplateList from "./TemplateList";

const { Search } = Input;
const { TabPane } = Tabs;

export default () => {
  const [search, setSearch] = useState<string>();
  const templates = useRootSelector(FireSel.backtestSnapshot);
  const templateGroup = groupBy(filterTemplates(), "tag");
  const [selectedTag, setSelectedTag] = useState(Object.keys(templateGroup)[0]);

  useEffect(() => {
    setSelectedTag(Object.keys(templateGroup)[0]);
  }, [search]);

  return (
    <Tabs
      activeKey={selectedTag}
      onChange={setSelectedTag}
      tabBarExtraContent={
        <Search placeholder={"Find snapshot"} onChange={e => setSearch(e.target.value)} style={{ width: 200 }} />
      }
    >
      {Object.entries(templateGroup).map(([tag, t]) => (
        <TabPane tab={tag} key={tag}>
          <TemplateList templates={t} />
        </TabPane>
      ))}
    </Tabs>
  );

  function filterTemplates() {
    const newTemplates = templates
      .filter(e => e)
      .map(e => ({
        ...e,
        tag: e.tag ? e.tag : "Default"
      }));

    if (search && search.length > 0) {
      const searchText = search.toLowerCase();
      return newTemplates.filter(
        e =>
          e.tag.toLowerCase().includes(searchText) ||
          e.name.toLowerCase().includes(searchText) ||
          e.date.includes(searchText) ||
          e.author.toLowerCase().includes(searchText)
      );
    }

    return newTemplates;
  }
};
